import { makeStyles } from "@material-ui/core/styles";
const premiumCss = makeStyles((theme) => ({
    premimumCard:{
        padding:32,
        paddingBottom:48,
        backgroundColor:'#fff',
        marginTop:24,
        borderRadius:8,
        boxShadow:'none',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        flexDirection:'column'
    },
    cardTitle:{
        fontSize:24,
        fontWeight:600,
        color:'#0b1323',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        marginBottom:16
    },
    actionInvoiceCard:{
        width:'100%',
        marginTop:24,
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between',
        backgroundColor:'#fafafa',
        borderRadius:8,
        padding:'24px 16px',
        color:'#1f2940',
        boxShadow:'none'
    },
    actionRenewCard:{
        width:'100%',
        marginTop:24,
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between',
        backgroundColor:'#ffebeb',
        borderRadius:8,
        padding:'24px 16px',
        color:'#1f2940',
        boxShadow:'none'
    },
    invoiceButton:{
        padding:'7px 30px',
        borderRadius:4,
        fontSize:14,
        fontWeight:600,
        textTransform:'none',
        color:'#fff',
        backgroundColor:'#5170f0',
        '&:hover':{
            backgroundColor:'#5170f0',
        }
    },
    renewButton:{
        padding:'7px 30px',
        borderRadius:4,
        fontSize:14,
        fontWeight:600,
        textTransform:'none',
        color:'#fff',
        backgroundColor:'#de1c22',
        '&:hover':{
            backgroundColor:'#de1c22',
        }
    },
    errorText:{
        display:'flex',
        alignItems:'center'
    },
    offerName:{
        backgroundColor:'#ffa412',
        padding:'10px 20px',
        borderRadius:56,
        fontWeight:'bold',
        color:'#fff',
        marginBottom:12,
        textAlign:'center'
    },
    offerAppliedMain: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    offerApplied:{
        backgroundColor:'#ffedd1',
        padding:'8px 12px',
        borderRadius:6,
        fontWeight:'bold',
        fontSize:16,
        color:'#1f2940',
        marginBottom:12,
        textAlign:'center',
        display:'flex',
        alignItems:'center',
        marginTop: 12,
        marginLeft: "auto",
        marginRight: "auto",
    },
    limitedOffer: {
        marginBottom: 24,
        fontSize: 20,
        fontWeight: 600,
        color: '#de1c22',
        textDecoration: 'line-through',
        textDecorationThickness: '3px',
        textAlign:'center',
        marginTop: 24
    },
    priceDiv: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 20,
        alignItems: 'center',
        justifyContent: "center"
    },
    originalPrice: {
        fontSize: 32,
        color: '#0b1323',
        margin: 0,
        fontWeight:'bold',
    },
    perYear: {
        fontSize: 14,
        color: '#6b778c',
        marginLeft: 8,
        marginBottom: 0,
        marginTop:12
    },
    upgradeButton:{
        padding:'16px 88px',
        borderRadius:8,
        fontSize:16,
        fontWeight:600,
        textTransform:'none',
        color:'#fff',
        boxShadow:'none',
        backgroundColor:'#5170f0',
        '&:hover':{
            backgroundColor:'#5170f0',
        }
    },
    unsuccess:{
        marginTop:24,
        marginBottom:16,
        fontSize:24,
        fontWeight:600,
        color:'#0b1323'
    },
    unsuccess2:{
        marginBottom:24,
        fontSize:16,
        color:'#6b778c'
    },
    retryButton:{
        padding:'16px 88px',
        borderRadius:8,
        fontSize:16,
        fontWeight:600,
        textTransform:'none',
        color:'#fff',
        boxShadow:'none',
        backgroundColor:'#de1c22',
        '&:hover':{
            backgroundColor:'#de1c22',
        }
    },
    doYouHaveCouponCode:{
        color:'#1f2940',
        fontSize:14,
        fontWeight:600,
        cursor:"pointer",
        textDecoration:'underline',
        marginBottom: 24,
        textAlign: "center",
        marginTop: 20
    },
    textField: {
        borderRadius:4,
        '& .MuiOutlinedInput-input': {
            padding: '14px 16px',
            backgroundColor: '#fff',
            boxShadow: 'inset 0 1px 2px 0 rgba(102, 113, 123, 0.21)'
        }
    },
    apply: {
        backgroundColor: '#5170f0',
        marginLeft: 8,
        fontSize:14,
        padding: "14px 16px",
        textTransform: "capitalize",
        lineHeight:1.25,
        alignSelf:'self-start'
    },
    applied: {
        backgroundColor: '#5170f0',
        marginLeft: 8,
        fontSize:14,
        padding: "14px 16px",
        textTransform: "capitalize",
        lineHeight:1.25,
        alignSelf:'self-start'
    },
    couponDialogPaper:{
        borderRadius:16
    },
    dialogTitleRoot:{
        margin: 0,
        //backgroundColor:'#0c8f64',
        background:'linear-gradient(#0c8f64 0 0) top/100% calc(100% - 5px) no-repeat,conic-gradient(from -45deg at bottom,#0000,#0c8f64 14deg 89deg,#0000 90deg) bottom/10px 5px repeat-x',
        padding: '20px 24px',
        fontSize: 20,
        fontWeight: 300,
        display: 'flex',
        alignItems: 'center',
        '& .MuiTypography-root': {
            fontSize: 20,
            fontWeight: 600,
            color:'#fff'
        },
        '& .MuiIconButton-root':{
            top:'auto'
        }
    },
    dialogContentRoot:{
        padding:'32px 24px'
    }
}));

export default premiumCss;